// extracted by mini-css-extract-plugin
export default {"board":"BoardComponent_board__dAKVZ"};